<template>
    <div
        v-if="isComponentReady"
        class="l-ss-c-offers"
        :class="wrapperClasses">
        <offers-wrapper
            :offers="offers"
            :view="options.view"
            ref="offersWrapper"
            v-on="offersWrapperEventListeners"/>
    </div>
</template>

<script>
    import { installPlugins } from '../core/plugins';

    import RootComponentMixin from '../core/mixins/root-component';
    import OffersWrapper from '../core/components/offers-wrapper';
    import EventEmitterMixin from '../core/mixins/event-emitter';

    installPlugins();

    export default {
        components: {
            OffersWrapper,
        },
        mixins: [
            RootComponentMixin,
            EventEmitterMixin,
        ],
        props: {
            ...RootComponentMixin.props,
            offers: {
                type: Array,
                default: () => ([]),
            },
        },
        computed: {
            ...RootComponentMixin.computed,
            offersWrapperEventListeners() {
                return {
                    'offer-click': this.emitOfferClick,
                    'add-to-cart': this.emitAddToCart,
                    'add-to-favourites-click': this.emitAddToFavouritesClick,
                    'remove-from-favourites-click': this.emitRemoveFromFavouritesClick,
                    'add-to-compare-click': this.emitAddToCompareClick,
                    'remove-from-compare-click': this.emitRemoveFromCompareClick,
                };
            },
        },
        mounted() {
            this.$nextTick(() => {
                if ('IntersectionObserver' in window && this.wrapperElement instanceof Element) {
                    const observer = new IntersectionObserver((entries, observer) => {
                        if ((entries || []).length > 0 && entries[0].isIntersecting) {
                            this.$refs.offersWrapper.handleArrows();
                            observer.disconnect();
                        }
                    });
                    observer.observe(this.wrapperElement);
                }
            });
        },
    };
</script>
